module.exports = __webpack_public_path__ + "static/img/bcg_unit1.a8e158fd.png";